;
define("quick_add.tpl", function(){});

